import React, { useState, useEffect, useContext } from "react";
import Modal from 'react-modal';
import "../home/home.css";
import { faChartLine, faTrophy, faLock, faLockOpen } from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "../authContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-regular-svg-icons";
import { faCheck, faChartArea, faArrowsUpDown } from "@fortawesome/free-solid-svg-icons";
import AnalysisChart from "./AnalysisChart";
import TradeFlyer from "../utils/TradeFlyer"
import axios from "axios";
import './SingleTrade.css'
import UpcomingMacroEvents from "../marketEvents/UpcomingMacroEvents";

Modal.setAppElement('#root');

function AiTradeSuggestionList() {
  const { userId, isAuthenticated } = useContext(AuthContext);
  const isLocal = window.location.hostname === "localhost";
  const baseUrl = isLocal
    ? "http://localhost:5000"
    : "https://www.trendscout.club";
  const [suggestions, setSuggestions] = useState([]);
  const [addedMap, setAddedMap] = useState({});
  const [openIndex, setOpenIndex] = useState(null);
  const [currentDateIndex, setCurrentDateIndex] = useState(0);
  const [groupedByDate, setGroupedByDate] = useState({});
  const [sortedDates, setSortedDates] = useState([]);
  const [visibleStatuses, setVisibleStatuses] = useState([]);
  const [dataset, setDataset] = useState("cryptoAnalysis");
  const [snapshot, setSnapshot] = useState(null);
  const [added, setAdded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [liquidityUpdateModal, setLiquidityUpdateModal] = useState(null);
  const [isChartOpen, setIsChartOpen] = useState(false);
  const [chartSymbol, setChartSymbol] = useState('');
  const [scoreSortOrder, setScoreSortOrder] = useState("");
  const isMobile = window.innerWidth <= 768;
  const [macroAi, setMacroAi] = React.useState(null);
  const [macroAiLoading, setMacroAiLoading] = React.useState(false);
  const [macroAiError, setMacroAiError] = React.useState(null);
  const [macroAiExpanded, setMacroAiExpanded] = React.useState(false);
  const [visibleRecommendations, setVisibleRecommendations] = useState([
    "BUY",
    "SELL",
    "STRONG SELL",
    "STRONG BUY"
  ]);
  const [visibleTrends, setVisibleTrends] = useState([ ]);
  const zoneMid = z => z ? (z.start + z.end) / 2 : undefined;
  const fmtPrice = p => (typeof p === "number" ? `$${p.toFixed(5)}` : "—");
  const fmtNum = n => (typeof n === "number" ? n.toLocaleString(undefined, { maximumFractionDigits: 1 }) : "—");
  const [tradeModal, setTradeModal] = useState({
      open: false,
      unlocked: false,      // session-level unlock
      pin: "",
      bot: "binance",       // "binance" | "bitget"
      direction: "LONG",    // "LONG" | "SHORT"
      qtyUsd: "",
      entry: null,
      tp: null,
      sl: null,
      token: "",
      rawSuggestion: null,
    });
  const currentDate = sortedDates[currentDateIndex];
  const currentSuggestions = groupedByDate[currentDate] || [];
  const [botLeverage, setBotLeverage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [showCharts, setShowCharts] = useState(true);
  const [loadingData, setLoadingData] = useState(false);
  const [loadingWhich, setLoadingWhich] = useState(dataset); 
  const [errorMsg, setErrorMsg] = useState(null);
  const cacheRef = React.useRef(new Map());           
  const controllerRef = React.useRef(null);           
  const buttonsRef = React.useRef(null);
  const prevTopRef = React.useRef(0);
  const restoreScrollRef = React.useRef(false);
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const scrollToBottom = () => {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
  };
  const [pulse, setPulse] = React.useState(null);
  const [pulseLoading, setPulseLoading] = React.useState(false);
  const [pulseError, setPulseError] = React.useState(null);
  const [pulseOpen, setPulseOpen] = React.useState(false);
  const DEBUG_TS = localStorage.getItem('DEBUG_TS') === '1';
  const dbg = (...a) => { if (DEBUG_TS) console.log('[TSDBG]', ...a); };
  localStorage.setItem('DEBUG_TS', '1')

// helpers
const toNum = (x) => Number(x);
const safeDiv = (a, b) =>
  Number.isFinite(a) && Number.isFinite(b) && b !== 0 ? a / b : null;


  const openChart = (tokenSymbol) => {
    const formatted = tokenSymbol.replace('/', '');
    setChartSymbol(`BINANCE:${formatted}`);
    setIsChartOpen(true);
  };

  const closeChart = () => setIsChartOpen(false);
// Derive side-specific zones from a saved heatmap + a price
  const deriveSideZones = (liq, price) => {
    const heatmap = liq?.heatmap || [];
    if (!heatmap.length || !Number.isFinite(price)) {
      return { topBidZoneBelow:null, nearestBidBelow:null, topAskZoneAbove:null, nearestAskAbove:null };
    }

    const isOB     = heatmap.some(z => (z?.bidVolume||0) > 0 || (z?.askVolume||0) > 0);
    const volAbove = (z) => isOB ? (z?.askVolume || 0) : (z?.volume || 0);
    const volBelow = (z) => isOB ? (z?.bidVolume || 0) : (z?.volume || 0);

    const withMid = heatmap.map(z => ({ ...z, mid: zoneMid(z) })).filter(z => Number.isFinite(z.mid));

    const above = withMid.filter(z => z.mid >  price);
    const below = withMid.filter(z => z.mid <  price);

    const topAskZoneAbove = (above.length
      ? [...above].sort((a,b) => volAbove(b) - volAbove(a))[0]
      : null) || null;

    const topBidZoneBelow = (below.length
      ? [...below].sort((a,b) => volBelow(b) - volBelow(a))[0]
      : null) || null;

    const nearestAskAbove = (above
      .filter(z => volAbove(z) > 0)
      .sort((a,b) => Math.abs(a.mid - price) - Math.abs(b.mid - price))[0]) || null;

    const nearestBidBelow = (below
      .filter(z => volBelow(z) > 0)
      .sort((a,b) => Math.abs(a.mid - price) - Math.abs(b.mid - price))[0]) || null;

    return { topBidZoneBelow, nearestBidBelow, topAskZoneAbove, nearestAskAbove };
  };

    const recToColor = (recRaw) => {
    const rec = (recRaw || "").toString().trim().toUpperCase();
    if (rec === "LONG") return "#19ff6b";   // green
    if (rec === "SHORT") return "#f44336";  // red
    if (rec === "SKIP") return "#f39c12";   // orange
    if (rec === "NEUTRAL") return "#84e1f9"; // blue
    return "#000000"; // anything else -> black
  };

  const outcomeFromTargetHit = (s) => {
    const hit = s?.outcome?.targetHit;
    if (hit === "tp") return "WIN";
    if (hit === "sl") return "LOSS";
    return null; // unknown / none
  };

const resultFromOutcome = (s) => {
  const hit = s?.outcome?.targetHit?.toLowerCase?.(); // "tp" | "sl" | "none"
  const rec35 = s?.analysis?.gpt35Recommendation?.toLowerCase?.(); // "long" | "short" | "skip" | ...
  const recGPT = s?.analysis?.recommendation?.toLowerCase?.(); // "buy", "sell", etc.

  if (!hit || !rec35) return null;

  const isBuySide = ["buy", "strong buy"].includes(recGPT);
  const isSellSide = ["sell", "strong sell"].includes(recGPT);

  // ✅ Case 1: TP hit + aligned direction
  if (hit === "tp") {
    const correctLong = rec35 === "long" && isBuySide;
    const correctShort = rec35 === "short" && isSellSide;
    if (correctLong || correctShort) return "Correct";
  }

  // ✅ Case 2: SL hit + skip or neutral
  if (hit === "sl" && (rec35 === "skip" || rec35 === "neutral")) {
    return "Correct";
  }

  // ✅ Case 3: SL hit + opposite directional alignment (AI was right to avoid)
  if (hit === "sl") {
    const oppositeLong = rec35 === "long" && isSellSide;
    const oppositeShort = rec35 === "short" && isBuySide;
    if (oppositeLong || oppositeShort) return "Correct";
  }

  // ❌ Otherwise incorrect
  return "Incorrect";
};




   useEffect(() => {
    fetch(`${baseUrl}/api/latest-market-snapshot`)
      .then((res) => res.json())
      .then((data) => setSnapshot(data))
      .catch((err) => console.error("Failed to load market snapshot", err));
  }, []);

  useEffect(() => {
  if (!tradeModal.open) return;
  const base =
    tradeModal.bot === 'binance'
      ? `${baseUrl}/api/binance/bot/status`
      : `${baseUrl}/api/bitget/bot/status`;

  (async () => {
    try {
      const r = await fetch(base);
      const j = await r.json();
      const lev = Number(j?.config?.leverage);
      if (Number.isFinite(lev) && lev > 0) setBotLeverage(lev);
    } catch {}
  })();
}, [tradeModal.open, tradeModal.bot]); 

  useEffect(() => {
    async function loadPortfolioIds() {
      try {
        const res = await fetch(`${baseUrl}/api/portfolio`, {
          headers: { "X-User-Id": userId }
        });
        const data = await res.json();
        const map = {};
        data.forEach(item => {
          map[item.recommendationId] = true;
        });
        setAddedMap(map);
      } catch (err) {
        console.error("Failed to load portfolio for initial state", err);
      }
    }
    if (userId) loadPortfolioIds();
  }, [userId]);

function switchDataset(next) {
  if (next === dataset) return;

  // Capture how far below the buttons the user currently is
  if (buttonsRef.current) {
    const rect = buttonsRef.current.getBoundingClientRect();
    const distanceFromButtons = window.scrollY + rect.top;
    // store in ref for later
    buttonsRef.current.dataset.scrollY = distanceFromButtons;
  }

  setDataset(next);
  setLoadingWhich(next);
  setErrorMsg(null);
}

React.useLayoutEffect(() => {
  if (!restoreScrollRef.current) return;
  // after DOM updated, measure new position of the buttons
  const newTop = buttonsRef.current?.getBoundingClientRect().top ?? prevTopRef.current;
  const delta = newTop - prevTopRef.current; // how much the buttons moved relative to the viewport
  if (delta !== 0) {
    window.scrollBy({ top: delta, left: 0, behavior: "auto" });
  }
  restoreScrollRef.current = false;
}, [dataset, loadingData, suggestions.length]);

React.useEffect(() => {
  let alive = true;
  const ctrl = new AbortController();

  async function loadPulse() {
    try {
      setPulseLoading(true);
      setPulseError(null);
      const r = await fetch(`${baseUrl}/api/market-pulse/latest`, { signal: ctrl.signal });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const j = await r.json();
      if (alive) setPulse(j);
    } catch (e) {
      if (e.name !== "AbortError") setPulseError("Market pulse unavailable");
    } finally {
      if (alive) setPulseLoading(false);
    }
  }

  // Initial fetch on mount
  loadPulse();

  // Refresh every 2 hours = 2 * 60 * 60 * 1000 = 7,200,000 ms
  const id = setInterval(loadPulse, 7200000);

  return () => {
    alive = false;
    ctrl.abort();
    clearInterval(id);
  };
}, [baseUrl]);


React.useEffect(() => {
  let alive = true;

  async function loadMacroAi() {
    try {
      setMacroAiLoading(true);
      setMacroAiError(null);

      // 👇 adjust path if your backend uses a different route
      const r = await fetch(`${baseUrl}/api/macro/macro-regime-ai/latest`);
      if (!r.ok) throw new Error(`HTTP ${r.status}`);

      const j = await r.json(); 
      // expect something like:
      // { direction: "bullish", explanation: "...", aiConfidence: 72, createdAt: "..." }

      if (alive) setMacroAi(j);
    } catch (e) {
      if (alive) setMacroAiError("AI macro prediction unavailable");
    } finally {
      if (alive) setMacroAiLoading(false);
    }
  }

  loadMacroAi();

  return () => {
    alive = false;
  };
}, [baseUrl]);


function pulseVisual(direction) {
  const d = (direction || "").toLowerCase();
  // icon can be emoji or swap to <img /> if you have SVGs
  switch (d) {
    case "bullish":     return { icon: "🐂",  cls: "pulse-bull-strong",  label: "Bullish" };
    case "recovery":    return { icon: "🐂",  cls: "pulse-bull-light",   label: "Recovery" };
    case "bearish":     return { icon: "🐻",  cls: "pulse-bear-strong",  label: "Bearish" };
    case "distribution":return { icon: "🐻",  cls: "pulse-bear-light",   label: "Distribution" };
    case "caution":     return { icon: "⚠️", cls: "pulse-caution",       label: "Caution" };
    case "whipsaw":      
      return { 
        icon: <FontAwesomeIcon icon={faArrowsUpDown} />, 
        cls: "pulse-whipsaw", 
        label: "Whipsaw" 
      };
    case "neutral":      return { icon: "🐢", cls: "pulse-neutral",       label: "Neutral" };
    default:             return { icon: "❔", cls: "pulse-unknown",       label: "Unknown" };
  }
}

function macroAiVisual(direction) {
  const d = (direction || "").toLowerCase();
  switch (d) {
    case "bullish":     return { icon: "🟢", cls: "macroai-bullish", label: "Bullish" };
    case "bearish":     return { icon: "🔴", cls: "macroai-bearish", label: "Bearish" };
    case "caution":     return { icon: "⚠️", cls: "macroai-caution", label: "Caution" };
    case "range": 
    case "neutral":     return { icon: "🟡", cls: "macroai-neutral", label: "Range / Neutral" };
    default:            return { icon: "❔", cls: "macroai-unknown", label: "Unknown" };
  }
}


React.useEffect(() => {
  if (!pulseOpen) return;
  const onClick = (e) => {
    const el = document.querySelector(".market-pulse-wrapper");
    if (el && !el.contains(e.target)) setPulseOpen(false);
  };
  window.addEventListener("mousedown", onClick);
  return () => window.removeEventListener("mousedown", onClick);
}, [pulseOpen]);

let filtered = currentSuggestions;

function getSourceIcon(source) {
  if (!source) return null;

  const lower = source.toLowerCase();

  if (lower.includes("binance trending")) {
    return (
      <span className="source-icon">
        <img src="/Binancelogo.png" alt="Binance" className="source-logo" />
        <span style={{ color: "limegreen", marginLeft: "4px" }}>▲</span>
      </span>
    );
  }

    if (lower.includes("binance top gainers")) {
    return (
      <span className="source-icon">
        <img src="/Binancelogo.png" alt="Binance" className="source-logo" />
        <FontAwesomeIcon icon={faTrophy} style={{ color: "gold", marginLeft: "4px" }} title="Top Gainer" />
      </span>
    );
  }

  if (lower.includes("binance losers")) {
    return (
      <span className="source-icon">
        <img src="/Binancelogo.png" alt="Binance" className="source-logo" />
        <span style={{ color: "red", marginLeft: "4px" }}>▼</span>
      </span>
    );
  }

  if (lower.includes("coingecko")) {
    return (
      <span className="source-icon">
        <img src="/cglogo.png" alt="CoinGecko" className="source-logo" />
      </span>
    );
  }

  return null;
}


// 1. Filter by Recommendation
if (visibleRecommendations.length) {
  filtered = filtered.filter((s) =>
    visibleRecommendations.includes(
      s.analysis?.recommendation?.toUpperCase?.() || ""
    )
  );
}

// 2. Filter by Trend (applied to remaining)
if (visibleTrends.length) {
  filtered = filtered.filter((s) => {
    const trend = s.analysis?.trendStrength?.toUpperCase?.() || "";
    const trendIsKnown = ["BULLISH", "BEARISH", "SIDEWAYS"].includes(trend);
    return (
      (trendIsKnown && visibleTrends.includes(trend)) ||
      (!trendIsKnown && visibleTrends.includes("OTHER"))
    );
  });
}

// 3. Filter by Status (applied to remaining)
if (visibleStatuses.length) {
  filtered = filtered.filter((s) =>
    visibleStatuses.includes(s.entryMonitor?.status?.toUpperCase())
  );
}

let filteredSuggestions = [...filtered];

if (scoreSortOrder === "asc") {
  filteredSuggestions.sort((a, b) => (a.analysis?.score || 0) - (b.analysis?.score || 0));
} else if (scoreSortOrder === "desc") {
  filteredSuggestions.sort((a, b) => (b.analysis?.score || 0) - (a.analysis?.score || 0));
}
if (searchQuery.trim() !== "") {
  const q = searchQuery.trim().toLowerCase();
  filteredSuggestions = filteredSuggestions.filter(s =>
    (s.token || "").toLowerCase().includes(q)
  );
}





  useEffect(() => {
    // cancel any in-flight request
    controllerRef.current?.abort();
    const ctrl = new AbortController();
    controllerRef.current = ctrl;

    setLoadingData(true);
    setErrorMsg(null);

    // If we have cache, show it instantly (stale-while-revalidate)
    const cached = cacheRef.current.get(dataset);
    if (cached) {
      setSuggestions(cached.suggestions);
      setGroupedByDate(cached.groupedByDate);
      setSortedDates(cached.sortedDates);
    } else {
      // optional: keep the list blank to avoid “wrong tab” feeling
      setSuggestions([]);
      setGroupedByDate({});
      setSortedDates([]);
    }

    // NOTE: limit rows & fields to speed up (see GROQ below)
    const groq = `*[_type == "${dataset}"] | order(timestamp desc)[0...200]`;

    const url = `https://5f89dy2h.api.sanity.io/v2021-03-25/data/query/production?query=${encodeURIComponent(groq)}`;

    fetch(url, { signal: ctrl.signal })
      .then(r => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then(result => {
        const data = result.result || [];
        const grouped = groupByDay(data);
        const dates = Object.keys(grouped).sort((a, b) => new Date(b) - new Date(a));

        // update UI
        setSuggestions(data);
        setGroupedByDate(grouped);
        setSortedDates(dates);

        // cache it
        cacheRef.current.set(dataset, { suggestions: data, groupedByDate: grouped, sortedDates: dates });
      })
      .catch(err => {
        if (err.name !== 'AbortError') {
          console.error("Sanity fetch error:", err);
          setErrorMsg("Failed to load data. Please try again.");
        }
      })
      .finally(() => {
        if (!ctrl.signal.aborted) setLoadingData(false);
      });

    return () => ctrl.abort();
  }, [dataset]);

  useEffect(() => {
    if (!loadingData && buttonsRef.current?.dataset.scrollY) {
      // restore scroll to the button top
      const y = parseFloat(buttonsRef.current.dataset.scrollY);
      window.scrollTo({ top: y, behavior: "auto" });
    }
  }, [loadingData]);

useEffect(() => {
  const container = document.querySelector('.suggestions-container');
  if (!container) return;
  if (loadingData) {
    const h = container.getBoundingClientRect().height;
    container.style.minHeight = `${h}px`;
  } else {
    container.style.minHeight = '';
  }
}, [loadingData]);


  function groupByDay(suggestions) {
    return suggestions.reduce((acc, item) => {
      const dateKey = new Date(item.timestamp).toISOString().split("T")[0];
      if (!acc[dateKey]) acc[dateKey] = [];
      acc[dateKey].push(item);
      return acc;
    }, {});
  }

  
  if (!suggestions.length) {
    return (
      <div className="single-suggestion-box">
          <div ref={buttonsRef} className="button-group" style={{ justifyContent: "center", marginBottom: "1rem" }}>
            {["cryptoAnalysis", "aitriggered", "aiinactive", "aiCompleted"].map((db) => (
              <button
                key={db}
                className={dataset === db ? "active-db" : ""}
                onClick={() => switchDataset(db)}
                disabled={loadingData && loadingWhich === db}
              >
                {db === "cryptoAnalysis" && "🟢 Active"}
                {db === "aitriggered" && "🚀 Triggered"}
                {db === "aiinactive" && "🛑 Inactive"}
                {db === "aiCompleted" && "✅ Completed"}
                {loadingData && loadingWhich === db ? " …" : ""}
              </button>
            ))}
          </div>

            {/* Loading and error indicators */}
            {loadingData && (
              <div className="loading-banner">
                Loading {loadingWhich === "cryptoAnalysis" ? "Active" :
                          loadingWhich === "aitriggered" ? "Triggered" :
                          loadingWhich === "aiinactive" ? "Inactive" : "Completed"}…
              </div>
            )}

            {!loadingData && cacheRef.current?.get(dataset) && (
              <div className="subtle-note">Updated just now</div>
            )}

            {errorMsg && <div className="error-banner">{errorMsg}</div>}



        
        <h3>
          <FontAwesomeIcon icon={faChartLine} /> AI Trade Suggestions
        </h3>
        <div>
          Loading<span className="dots"></span>
        </div>
      </div>
    );
  }

  const addToPortfolio = async (s) => {
    const recommendation = s.analysis.recommendation;
    const { _id, token, priceAtAnalysis, longPosition, shortPosition } = s;
    const payload = { recommendationId: _id, token, entryPrice: priceAtAnalysis, longPosition, shortPosition, recommendation };
    try {
      const res = await fetch(`${baseUrl}/api/portfolio`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-User-Id": userId },
        body: JSON.stringify(payload)
      });
      if (res.ok) {
        setAddedMap(prev => ({ ...prev, [_id]: true }));
      } else {
        console.error("Add to portfolio failed:", await res.text());
      }
    } catch (err) {
      console.error("Error adding to portfolio", err);
    }
  };

  // if not authenticated, returns a blurred span; otherwise returns children
function BlurIfLocked({ children }) {
  return isAuthenticated
    ? children
    : <span className="blurred-content">{children}</span>;
}

const getConfidenceClass = (confidence) => {
  if (confidence == null) return "";
  if (confidence < 50) return "confidence-red";
  if (confidence > 80) return "confidence-green";
  return "confidence-orange";
};

function cleanAnalysis(s = "") {
  // try to remove a trailing {...} blob that starts on the last line
  const i = s.lastIndexOf("{");
  if (i > -1) {
    const tail = s.slice(i);
    try { JSON.parse(tail); return s.slice(0, i).trim(); } catch {}
  }
  return s;
}

      function pickDirectionFromSuggestion(s) {
        const rec = s?.analysis?.recommendation?.toUpperCase?.() || "";
        if (rec.includes("BUY")) return "LONG";
        if (rec.includes("SELL")) return "SHORT";
        if ((s?.analysis?.upsideChance || 0) > (s?.analysis?.downsideChance || 0)) return "LONG";
        if ((s?.analysis?.upsideChance || 0) < (s?.analysis?.downsideChance || 0)) return "SHORT";
        return "LONG";
      }

      function planFor(s, direction) {
        const p = direction === "LONG" ? s?.longPosition : s?.shortPosition;
        return {
          entry: Number(p?.entry) || null,
          tp:    Number(p?.tp)    || null,
          sl:    Number(p?.sl)    || null,
        };
      }

      const isFivePctDiff = (entry, tp, tolerance = 0.05) => {
        if (!Number.isFinite(entry) || !Number.isFinite(tp) || entry === 0) return false;
        const diff = Math.abs((tp - entry) / entry) * 100;
        return Math.abs(diff - 5) <= tolerance; // 5% ± 0.05%
      };


      function cleanSymbolForExchange(token, exchange) {
        if (exchange === "binance") {
          // e.g. "ANKR/USDT" -> "ANKRUSDT"
          return String(token || "").toUpperCase().replace("/", "");
        }
        // bitget: let backend normalize (BTC/USDT -> BTC/USDT:USDT internally)
        return String(token || "").toUpperCase();
      }

      async function openTradeWithPin(rawSuggestion) {
        const token = localStorage.getItem('token');
        const pin = window.prompt('Enter trading PIN');  // replace with your own PIN UI if you prefer
        if (!pin) return; // cancelled

        try {
          await axios.post(
            `${baseUrl}/api/security/verify-pin`,
            { pin },
            { headers: token ? { Authorization: `Bearer ${token}` } : {} }
          );

          // ✅ PIN ok → open modal unlocked
          const dir  = 'LONG'; // or infer from suggestion
          const plan = planFor(rawSuggestion, dir); // your helper
          setTradeModal({
            open: true,
            unlocked: true,
            pin: '',
            bot: 'binance',
            token: rawSuggestion.token,
            rawSuggestion,
            direction: dir,
            qtyUsd: '',
            entry: plan.entry,
            tp: plan.tp,
            sl: plan.sl,
          });
        } catch (e) {
          alert('Incorrect PIN.');
          // ❌ do NOT open the modal
        }
      }


 async function submitOpenPosition() {
   try {
     const m = tradeModal;
     const s = m.rawSuggestion;

     // 1) Basic validation
     const entry = Number(m.entry);
     const tp    = Number(m.tp);
     const sl    = Number(m.sl);
     if (![entry, tp, sl].every(Number.isFinite)) {
       alert("Please provide valid Entry, TP and SL.");
       return;
     }

     // 2) Prepare auth headers
     const token = localStorage.getItem("token");
     const headers = token ? { Authorization: `Bearer ${token}` } : {};

     // 3) Verify PIN once per session
     if (!m.unlocked) {
       if (!m.pin || m.pin.length < 4) {
         alert("Enter your trading PIN (min 4 chars).");
         return;
       }
       try {
         await axios.post(`${baseUrl}/api/security/verify-pin`, { pin: m.pin }, { headers });
         setTradeModal(prev => ({ ...prev, unlocked: true, pin: "" }));
       } catch (e) {
         alert("Incorrect PIN.");
         return;
       }
     }


    // Derive recommendation word from chosen direction (BUY/SELL)
    const recWord = m.direction === "LONG" ? "BUY" : "SELL";

    // Optionally attach marketPulse if your backend rules use it
    const marketPulse = (typeof pulse?.direction === 'string')
      ? String(pulse.direction).toLowerCase()
      : undefined;

     const payloadSuggestion = {
       token: cleanSymbolForExchange(s.token, m.bot),
       qtyUsd: Number.isFinite(Number(m.qtyUsd)) ? Number(m.qtyUsd) : undefined,
       analysis: {
         recommendation: recWord,
         score: s?.analysis?.score,
         trendPhase: s?.analysis?.trendPhase,
         expectedDirection24h: s?.analysis?.expectedDirection24h,
        marketPulse, // <— makes conditional rules debuggable if you use pulses
       },
       longPosition:  m.direction === "LONG"  ? { entry, tp, sl } : undefined,
       shortPosition: m.direction === "SHORT" ? { entry, tp, sl } : undefined,
     };

     const body = { suggestions: [payloadSuggestion] };

     const endpoint =
       m.bot === "binance"
         ? `${baseUrl}/api/binance/bot/execute-trades`
         : `${baseUrl}/api/bitget/manual/execute`;

    // ======== FRONTEND DEBUG START ========
    console.groupCollapsed('%c[TSDBG] Submit trade', 'color:#7bd');
    dbg('endpoint:', endpoint);
    dbg('payload:', JSON.parse(JSON.stringify(body)));
    dbg('botLeverage:', botLeverage);
    dbg('dataset:', dataset);
    console.groupEnd();
    // ======== FRONTEND DEBUG END =========

    const { data } = await axios.post(endpoint, body, { headers });
    console.groupCollapsed('%c[TSDBG] Server reply', 'color:#7bd');
    dbg('raw data:', data);
    const exec = data?.executed?.[0];
    const status = exec?.result?.status || exec?.result || 'UNKNOWN';
    dbg('status:', status);
    dbg('exec object:', exec);
    console.groupEnd();

    if (!exec) {
      alert(`No orders placed. ${data?.disabled ? 'Bot disabled.' : 'Check server logs for guards.'}`);
      return;
    }

    if (status === 'FILLED_MARKET' || status === 'TEST_MARKET') {
      alert('Order placed successfully.');
      setTradeModal(prev => ({ ...prev, open: false }));
      return;
    }

    const tol = exec?.result?.tolPct;
    const dev = exec?.result?.deviationPct;
    const marginMode = exec?.result?.marginMode || exec?.marginMode;
    alert(`Trade skipped: ${status}
• deviation: ${dev != null ? dev.toFixed?.(3) + '%' : 'n/a'} vs tol ${tol ?? 'n/a'}%
• margin mode: ${marginMode || 'n/a'}
Check console for full payload/reply.`);
   } catch (e) {
    console.groupCollapsed('%c[TSDBG] Submit error', 'color:#f66');
    console.error(e);
    console.error('response?.data:', e?.response?.data);
    console.groupEnd();
     alert(`Open failed: ${e?.response?.data?.error || e.message}`);
   }
 }



  return (
    <div className="ai-suggestion-list">
      <UpcomingMacroEvents />
      {snapshot && (
        <div className="details-panel market-snapshot-panel">
          <div className="snapshot-header">
            <h3>📊 Market Snapshot</h3>
            <span className="snapshot-timestamp">
              {new Date(snapshot.createdAt).toLocaleString()}
            </span>
          </div>
          {/* Floating Market Pulse badge (top-left under header) */}
          {(pulse || pulseLoading || pulseError) && (
            <div className={`market-pulse-wrapper ${pulseOpen ? "open" : ""}`}>
              <button
                className={`pulse-chip pulse-skin ${pulse ? pulseVisual(pulse.direction).cls : ""}`}
                onClick={() => setPulseOpen(o => !o)}
                aria-expanded={pulseOpen}
                title={
                  pulse
                    ? `Rule: ${pulse.rule} • Confidence: ${pulse.confidence}%`
                    : pulseError || "Loading..."
                }
              >
                {(() => {
                  if (pulseLoading) return <span className="pulse-text">⏳ Loading…</span>;
                  if (pulseError)   return <span className="pulse-text">⚠️ Unavailable</span>;
                  const v = pulseVisual(pulse.direction);
                  return (
                    <>
                      <span className="pulse-icon">{v.icon}</span>
                      <span className="pulse-text">{v.label}</span>
                      <span className="pulse-caret" aria-hidden>▾</span>
                    </>
                  );
                })()}
              </button>

              {/* Expanding panel */}
              <div className="pulse-panel" role="dialog" aria-label="Market pulse details">
                {pulse && (
                  <>
                     <div className="pulse-row-header">
                      <span className="v">Predicted direction for Today</span>
                    </div>
                    <div className="pulse-row">
                      <span className="k">Direction</span>
                      <span className="v">{pulseVisual(pulse.direction).label}</span>
                    </div>
                    <div className="pulse-row">
                      <span className="k">Confidence</span>
                      <span className="v">{pulse.confidence}%</span>
                    </div>

                    {/* Intraday override (if present) */}
                    {pulse.lastOverride && (
                      <>
                        <div className="pulse-divider">Override</div>
                        <div className="pulse-row">
                          <span className="k">From → To</span>
                          <span className="v">
                            {pulse.lastOverride.from} → {pulse.lastOverride.to}
                          </span>
                        </div>
                        {pulse.lastOverride.reason && (
                          <div className="pulse-row">
                            <span className="k">Reason</span>
                            <span className="v">{pulse.lastOverride.reason}</span>
                          </div>
                        )}
                      </>
                    )}

                    {pulse.prevDayRatios && Object.keys(pulse.prevDayRatios).length > 0 && (
                      <>
                        <div className="pulse-divider">Ratios Used</div>
                        {Object.entries(pulse.prevDayRatios).map(([k, v]) => (
                          <div className="pulse-row" key={k}>
                            <span className="k">{k}</span>
                            <span className="v">{(v * 100).toFixed(1)}%</span>
                          </div>
                        ))}
                      </>
                    )}

                  </>
                )}

              </div>
            </div>
          )}


    <div className="snapshot-grid">
      <div className="snapshot-item">
        <span className="label">BTC Dominance</span>
        <span className="value">
          <BlurIfLocked>
          {snapshot.btcDominance.toFixed(2)}%
          <span className={`trend-badge ${snapshot.trend?.btcDominance}`}> ({snapshot.trend?.btcDominance})</span>
          </BlurIfLocked>
        </span>
      </div>
      <div className="snapshot-item"> 
        <span className="label">USDT Dominance</span>
        <span className="value">
          <BlurIfLocked>
          {snapshot.usdtDominance.toFixed(2)}%
          <span className={`trend-badge ${snapshot.trend?.usdtDominance}`}> ({snapshot.trend?.usdtDominance})</span>
          </BlurIfLocked>
        </span>
      </div>
      <div className="snapshot-item">
        <span className="label">ETH/BTC</span>
        <span className="value">
          <BlurIfLocked>
          {snapshot.ethBTC.toFixed(4)}
          <span className={`trend-badge ${snapshot.trend?.ethBTC}`}> ({snapshot.trend?.ethBTC})</span>
          </BlurIfLocked>
        </span>
      </div>
      <div className="snapshot-item">
        <span className="label">TOTAL3</span>
        <span className="value">
          <BlurIfLocked>
          ${(snapshot.total3 / 1e9).toFixed(2)}B
          <span className={`trend-badge ${snapshot.trend?.total3}`}> ({snapshot.trend?.total3})</span>
          </BlurIfLocked>
        </span>
      </div>
        <div className="snapshot-item">
        <span className="label">VOLUME</span>
        <span className="value">
          <BlurIfLocked>
          ${(snapshot.volumeTopCryptos / 1e9).toFixed(2)}B
          <span className={`trend-badge ${snapshot.trend?.volumeTopCryptos}`}> ({snapshot.trend?.volumeTopCryptos})</span>
          </BlurIfLocked>
        </span>
      </div>
    </div>
<div className="snapshot-item-analysis">
  <p className="snapshot-analysis">
    <BlurIfLocked>
      {cleanAnalysis(snapshot.aiMarketAnalysis)}
      {snapshot.aiConfidence != null && (
        <span className={`ai-confidence ${getConfidenceClass(snapshot.aiConfidence)}`}>
          (AI Confidence: {snapshot.aiConfidence}%)
        </span>
      )}
    </BlurIfLocked>
  </p>
</div>

      {/* 🔮 24h Macro AI Prediction (new) */}
      {(macroAi || macroAiLoading || macroAiError) && (
        <div className="snapshot-item-analysis macroai-panel">
          <BlurIfLocked>
            {macroAiLoading && (
              <div className="macroai-row">
                <span className="macroai-label">24h AI Macro Regime:</span>
                <span className="macroai-value">Loading…</span>
              </div>
            )}

            {macroAiError && !macroAiLoading && (
              <div className="macroai-row">
                <span className="macroai-label">24h AI Macro Regime:</span>
                <span className="macroai-value macroai-error">{macroAiError}</span>
              </div>
            )}

            {macroAi && !macroAiLoading && !macroAiError && (() => {
              const v = macroAiVisual(macroAi.direction);
              return (
                <div className="macroai-content">
                  <div className={`macroai-chip ${v.cls}`}>
                    <span className="macroai-icon">{v.icon}</span>
                    <span className="macroai-text">
                      24h AI Macro Regime: <strong>{v.label}</strong>
                    </span>
                    {typeof macroAi.aiConfidence === "number" && (
                      <span className="macroai-conf">
                        {macroAi.aiConfidence.toFixed(0)}%
                      </span>
                    )}

                    {/* ⬇️ toggle button – direction always visible, controls explanation */}
                    {macroAi.explanation && (
                      <button
                        type="button"
                        className="macroai-toggle"
                        onClick={() => setMacroAiExpanded((prev) => !prev)}
                      >
                        {macroAiExpanded ? "Hide details ▲" : "Show details ▼"}
                      </button>
                    )}
                  </div>

                  {/* ⬇️ explanation only when expanded */}
                  {macroAi.explanation && macroAiExpanded && (
                    <p className="macroai-explanation">
                      {macroAi.explanation}
                    </p>
                  )}
                </div>
              );
            })()}
          </BlurIfLocked>
        </div>
      )}



  </div>
)}


          <div ref={buttonsRef} className="button-group" style={{ justifyContent: "center", marginBottom: "1rem" }}>
            {["cryptoAnalysis", "aitriggered", "aiinactive", "aiCompleted"].map((db) => (
              <button
                key={db}
                className={dataset === db ? "active-db" : ""}
                onClick={() => switchDataset(db)}
                disabled={loadingData && loadingWhich === db}
              >
                {db === "cryptoAnalysis" && "🟢 Active"}
                {db === "aitriggered" && "🚀 Triggered"}
                {db === "aiinactive" && "🛑 Inactive"}
                {db === "aiCompleted" && "✅ Completed"}
                {loadingData && loadingWhich === db ? " …" : ""}
              </button>
            ))}
          </div>

          {/* Loading and error indicators */}
            {loadingData && (
              <div className="loading-banner">
                Loading {loadingWhich === "cryptoAnalysis" ? "Active" :
                          loadingWhich === "aitriggered" ? "Triggered" :
                          loadingWhich === "aiinactive" ? "Inactive" : "Completed"}…
              </div>
            )}

            {!loadingData && cacheRef.current?.get(dataset) && (
              <div className="subtle-note">Updated just now</div>
            )}

            {errorMsg && <div className="error-banner">{errorMsg}</div>}
          {isAuthenticated && (
          <div className="filter-section">
            <div className="filter-group">
              <span className="filter-label">Recommendation</span>
              {["BUY", "SELL", "STRONG SELL", "STRONG BUY"].map((type) => (
                <label key={type} className="custom-checkbox">
                  <input
                    type="checkbox"
                    checked={visibleRecommendations.includes(type)}
                    onChange={() => {
                      setVisibleRecommendations((prev) =>
                        prev.includes(type)
                          ? prev.filter((t) => t !== type)
                          : [...prev, type]
                      );
                    }}
                  />
                  <span className="checkmark" />
                  {type}
                </label>
              ))}
            </div>

            <div className="filter-group">
              <span className="filter-label">Trend</span>
              {["BULLISH", "BEARISH", "SIDEWAYS", "OTHER"].map((trend) => (
                <label key={trend} className="custom-checkbox">
                  <input
                    type="checkbox"
                    checked={visibleTrends.includes(trend)}
                    onChange={() => {
                      setVisibleTrends((prev) =>
                        prev.includes(trend)
                          ? prev.filter((t) => t !== trend)
                          : [...prev, trend]
                      );
                    }}
                  />
                  <span className="checkmark" />
                  {trend}
                </label>
              ))}
            </div>

          <div className="filter-group">
              <span className="filter-label">Sort by Score</span>
            <select className="filter-select"
              onChange={(e) => setScoreSortOrder(e.target.value)}
              value={scoreSortOrder}
            >
              <option value="">None</option>
              <option value="asc">Lowest → Highest</option>
              <option value="desc">Highest → Lowest</option>
            </select>
            <span className="filter-label">Status</span>
            {["TRIGGERED", "CANCELLED"].map((status) => (
              <label key={status} className="custom-checkbox">
                <input
                  type="checkbox"
                  checked={visibleStatuses.includes(status)}
                  onChange={() => {
                    setVisibleStatuses((prev) =>
                      prev.includes(status)
                        ? prev.filter((s) => s !== status)
                        : [...prev, status]
                    );
                  }}
                />
                <span className="checkmark" />
                {status}
              </label>
            ))}
          </div>
          </div>
          )}

      <div className="filter-section" style={{ textAlign: "center", marginBottom: "1rem" }}>
        <div className="button-group">
      <input
        type="text"
        placeholder="Search token..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="search-input"
        style={{
          padding: "6px 10px",
          borderRadius: "6px",
          border: "1px solid #555",
          background: "#111",
          color: "#fff",
          width: "220px"
        }}
      />
        <button
          onClick={() => setShowCharts(prev => !prev)}
          className="button-group button"
        >
          {showCharts ? "Hide Charts" : "Show Charts"}
        </button>
        </div>
    </div>

      {filteredSuggestions.map((s, i) => {
        const trend = s.analysis.trendStrength?.toLowerCase();
          // ✅ Pick the side (you said this is already correct)
          const dirToShow = pickDirectionFromSuggestion(s); // "LONG" | "SHORT"

          // ✅ Use the plan for the picked side
          const plan = planFor(s, dirToShow); // { entry, tp, sl }

          // ✅ Mark "Flipped" if the picked side's TP is ~5% from its entry
          const flipped = isFivePctDiff(plan.entry, plan.tp); // 5% ± 0.15%



        const analyzedAt = new Date(s.timestamp).toLocaleString("en-US", {
          day: "2-digit",
          month: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true
        });

        const triggerStatus = s.entryMonitor?.status?.toUpperCase?.();
        const showTrigger = ["TRIGGERED", "CANCELLED", "INVALIDATED"].includes(
          triggerStatus
        );

        const recommendation = s.analysis.recommendation?.toUpperCase();
        const isUpsideRelevant =
          recommendation === "BUY" || recommendation === "STRONG BUY";

        const isDownsideRelevant = recommendation === "SELL" || recommendation === "STRONG SELL";

        const tooltipText = isUpsideRelevant
          ? "Confidence reflects Upside potential"
          : isDownsideRelevant
          ? "Confidence reflects Downside potential"
          : "Confidence reflects overall market sentiment";

        const isShort = dirToShow === "SHORT";
        const entryPrice = plan.entry;
        const tpPrice    = plan.tp;

        const gainValue = (Number.isFinite(entryPrice) && Number.isFinite(s.currentPrice))
          ? (isShort
              ? ((entryPrice - s.currentPrice) / entryPrice) * 100
              : ((s.currentPrice - entryPrice) / entryPrice) * 100)
          : 0;

        const leftToTP = (Number.isFinite(tpPrice) && Number.isFinite(s.currentPrice) && s.currentPrice !== 0)
          ? (isShort
              ? ((s.currentPrice - tpPrice) / s.currentPrice) * 100
              : ((tpPrice - s.currentPrice) / s.currentPrice) * 100)
          : 0;


function formatNumberShort(n) {
  if (n == null || isNaN(n)) return "N/A"; // ✅ defensive check
  if (n >= 1_000_000_000) return (n / 1_000_000_000).toFixed(1) + " B";
  if (n >= 1_000_000) return (n / 1_000_000).toFixed(1) + " M";
  if (n >= 1_000) return (n / 1_000).toFixed(1) + " K";
  return n.toString();
}

const getZoneVolume = (zone, isOB) =>
  isOB ? ((zone?.bidVolume || 0) + (zone?.askVolume || 0)) : (zone?.volume || 0);

const isOrderBookMode = (heatmap = []) =>
  heatmap.some(z => (z?.bidVolume || 0) > 0 || (z?.askVolume || 0) > 0);

const totalVolumeFor = (heatmap = [], isOB) =>
  heatmap.reduce((sum, z) => sum + getZoneVolume(z, isOB), 0);


const eq = (a, b) => JSON.stringify(a) === JSON.stringify(b); // keep if you still want it

// consider zones equal if their start/end moved less than eps
const zoneEq = (a, b, eps = 1e-8) => {
  if (!a && !b) return true;
  if (!a || !b) return false;
  return Math.abs((a.start ?? 0) - (b.start ?? 0)) < eps &&
         Math.abs((a.end   ?? 0) - (b.end   ?? 0)) < eps;
};

// detect if we switched from candle-mode to order-book-mode (or vice versa)
const isOB = (heatmap = []) =>
  heatmap?.some?.(z => (z?.bidVolume || 0) > 0 || (z?.askVolume || 0) > 0);

// (optional) detect a *meaningful* move: zone crossed at least ~half a bucket
const bucketSizeOf = (heatmap = []) => {
  if (!heatmap?.length) return null;
  const z0 = heatmap[0];
  return (z0?.end ?? 0) - (z0?.start ?? 0) || null;
};

const fmt = (n) =>
  typeof n === "number"
    ? n.toLocaleString(undefined, { maximumFractionDigits: 2 })
    : "—";


const handleUpdateLiquidity = async () => {
  try {
    setLoading(true);
    const cleanSymbol = s.token.replace("/", "");
    const res = await fetch(`${baseUrl}/api/update-liquidity/${cleanSymbol}`);
    const { liquidity } = await res.json();

    const old = s.liquidityZones || {};
    const newLiq = liquidity || {};

    // base flags (tolerant)
    const topChangedBasic    = !zoneEq(old.topZone,    newLiq.topZone);
    const bottomChangedBasic = !zoneEq(old.bottomZone, newLiq.bottomZone);
    const biasChanged        = (old.bias || "neutral") !== (newLiq.bias || "neutral");

    // (optional) significance filter using bucket size
    const bsOld = bucketSizeOf(old.heatmap);
    const bsNew = bucketSizeOf(newLiq.heatmap);
    const bs    = bsNew ?? bsOld ?? 0;

    const movedEnough = (prev, next, frac = 0.5) => {
      if (!prev || !next || !bs) return true; // if unknown, assume meaningful
      const moved = Math.abs((next.start ?? 0) - (prev.start ?? 0));
      return moved >= bs * frac; // moved at least half a bucket
    };

    const topChanged    = topChangedBasic    && movedEnough(old.topZone,    newLiq.topZone);
    const bottomChanged = bottomChangedBasic && movedEnough(old.bottomZone, newLiq.bottomZone);

    // mode-change (candle vs order-book) is useful to show
    const modeChanged = isOB(old.heatmap) !== isOB(newLiq.heatmap);

    setLiquidityUpdateModal({
      show: true,
      updated: newLiq,
      changes: { topChanged, bottomChanged, biasChanged, modeChanged },
    });

    // (optional) if you also want to update s.liquidityZones after showing modal:
    // setS(prev => ({ ...prev, liquidityZones: newLiq }));

  } catch (err) {
    console.error("Failed to update liquidity", err);
  } finally {
    setLoading(false);
  }
};




      function formatPriceDynamic(price) {
        const num = Number(price);

        if (!Number.isFinite(num)) return "N/A";

        const abs = Math.abs(num);

        if (abs >= 1) {
          return num.toFixed(2);
        }

        if (abs >= 0.01) {
          return num.toFixed(4);
        }

        if (abs >= 0.0001) {
          return num.toFixed(6);
        }

        // For micro prices like 0.00000012, show up to 10 decimals and strip trailing zeros
        const fixed = num.toFixed(10).replace(/\.?0+$/, '');
        return fixed;
      }



        return (
          <div key={i} className="single-suggestion-box enhanced-layout">
              {dataset === "aiCompleted" && (() => {
                const outcome = outcomeFromTargetHit(s);
                if (!outcome) return null;

                const correctness = resultFromOutcome(s);

                return (
                  <div className="ai-outcome-row">
                    <span className={`ai-outcome-pill ${outcome === "WIN" ? "win" : "loss"}`}>
                      {outcome}
                    </span>
                    {correctness && (
                      <span
                        className={`ai-correctness-pill ${
                          correctness === "Correct" ? "correct" : "incorrect"
                        }`}
                      >
                        {correctness}
                      </span>
                    )}
                  </div>
                );
              })()}
            <div className="timestamp-container">
              <div className="timestamp-top-left">
                {analyzedAt} -- 
                <div className="phone-hide">
               <span style={{ color: s.analysis.priceChange24h >= 0 ? "limegreen" : "red" }}>
                  {s.analysis.priceChange24h >= 0 ? "▲" : "▼"} {Math.abs(s.analysis.priceChange24h).toFixed(2)}% 24hr{" -- "}
                </span>
                </div>
                <span>{getSourceIcon(s.analysis?.source)}</span>
              </div>

              
              <div className="timestamp-iconbox">
                  {isAuthenticated && (
                    <>
                      <div className="timestamp-top-right">
                        <FontAwesomeIcon
                          icon={tradeModal.unlocked ? faLockOpen : faLock}
                          title={tradeModal.unlocked ? "Trading unlocked" : "Open trade (PIN)"}
                          className="share-link icon-button"
                          onClick={() => openTradeWithPin(s)}
                          style={{ cursor: "pointer" }}
                        />
                      </div>

                      <div className="timestamp-top-right">
                        <TradeFlyer suggestion={s} />
                      </div>
                    </>
                  )}
                  {isAuthenticated && (
                    <div className="timestamp-top-right">
                      <FontAwesomeIcon
                        icon={addedMap[s._id] ? faCheck : faStar}
                        onClick={() => { if (!addedMap[s._id]) addToPortfolio(s); }}
                        title={addedMap[s._id] ? "In Portfolio" : "Add to Portfolio"}
                        className={`share-link icon-button ${addedMap[s._id] ? 'disabled' : ''}`}
                      />
                    </div>
                  )}
                  <div className="timestamp-top-right">
                    <FontAwesomeIcon
                      icon={faChartArea}
                      onClick={() => openChart(s.token)}
                      title="Trading View Chart"
                      className="share-link icon-button"
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                </div>
            </div>
            

            <BlurIfLocked>
            <div
              className="header-row"
              onClick={() => setOpenIndex(openIndex === i ? null : i)}
            >
              <div className="trade-data-box">
              <div className="top-row-text-ai">
                {i + 1}. {s.token} 
                  {s.longPosition?.tp > 0 && s.shortPosition?.tp > 0 && (
                    <FontAwesomeIcon
                      icon={faStar}
                      className="twowaytrade"
                      title="Dual‐edge setup"
                    />
                  )}
                 </div>
                <span className="token-price-mc">
                  PR ${s.priceAtAnalysis?.toFixed(4)}
                </span> 
             
              </div>
              <div className="trade-data-box">
                <div className="trend-with-dot">
                  {/* dot with tooltip */}
                  <span
                    className="rec-dot"
                    style={{ backgroundColor: recToColor(s.analysis?.gpt35Recommendation) }}
                    title={`AI TEST: ${(s.analysis?.gpt35Recommendation || "Unknown").toString()}`}
                  />
                  <span className={trend === "bullish" ? "green-text" : "red-text"}>
                    {s.analysis.trendStrength}
                  </span>
                </div>
                <span className="token-price-mc">
                  <span>MC ${formatNumberShort(s.analysis?.marketCap)}</span>
                </span> 
                
            </div>


                    
              <div className="trade-data-box">
              <div className="top-row-text-ai-2">
                <strong>{s.analysis.recommendation} / {s.analysis.tradeType}</strong>
              </div>
              <div
                className="top-row-text-ai-4-phone"
                  style={{
                    ...(s.analysis.score < 6 && {
                      color: "red"
                    }),
                    ...(s.analysis.score >= 6 && s.analysis.score < 9 && {
                      color: "orange"
                    }),
                    ...(s.analysis.score >= 9 && s.analysis.score < 12 && {
                      color: "#19ff6b"
                    }),
                    ...(s.analysis.score >= 12 && {
                      color: "#330596ff",
                      backgroundColor: "#19ff6b",
                      border: "2px solid #19ff6b",
                      borderRadius: "6px",
                      padding: "2px 6px"
                    })
                  }}
                >

                    Score: {s.analysis.score || 0}
                </div>
                  <div
                    className={`top-row-text-ai-2 ${flipped ? "flipped-badge" : ""} ${
                      !flipped
                        ? (s.analysis.confidenceLevel >= 7
                            ? "confidence-green"
                            : s.analysis.confidenceLevel <= 5
                            ? "confidence-red"
                            : "")
                        : ""
                    }`}
                    title={flipped ? "Entry is ~5% from TP" : tooltipText}
                  >
                    {flipped ? (
                      <strong>Flipped</strong>
                    ) : (
                      <>
                        <strong>Confidence:</strong> {s.analysis.confidenceLevel}/10
                      </>
                    )}
                  </div>
                </div>

                <div className="trade-data-box">
              <div
                className={`top-row-text-ai-2 ${
                  isUpsideRelevant ? "confidence-highlight" : ""
                }`}
              >
                <strong>Upside:</strong> ${s.analysis.upsideTarget} (
                {s.analysis.upsideChance})
              </div>
              <div className="top-row-text-ai-4-phone"
                  style={{
                    ...(s.analysis.score < 6 && {
                      color: "red"
                    }),
                    ...(s.analysis.score >= 6 && s.analysis.score < 9 && {
                      color: "orange"
                    }),
                    ...(s.analysis.score >= 9 && s.analysis.score < 12 && {
                      color: "#19ff6b"
                    }),
                    ...(s.analysis.score >= 12 && {
                      color: "#330596ff",
                      backgroundColor: "#19ff6b",
                      border: "2px solid #19ff6b",
                      borderRadius: "6px",
                      padding: "2px 6px"
                    })
                  }}
                >
                      {s.analysis.scoreMeaning || "NA"}
                    </div>
              <div
                className={`top-row-text-ai-2 ${
                  isDownsideRelevant ? "confidence-highlight" : ""
                }`}
              >
                <strong>Downside:</strong> ${s.analysis.downsideRisk} (
                {s.analysis.downsideChance})
              </div>
              </div>
            </div>

                  {/* SCORING */}
                <div className="header-row-position-main-scoring">
                  <div className="header-position-box">
                  <span
                    className="token-price-scoring"
                  style={{
                    ...(s.analysis.score < 6 && {
                      color: "red"
                    }),
                    ...(s.analysis.score >= 6 && s.analysis.score < 9 && {
                      color: "orange"
                    }),
                    ...(s.analysis.score >= 9 && s.analysis.score < 12 && {
                      color: "#19ff6b"
                    }),
                    ...(s.analysis.score >= 12 && {
                      color: "#330596ff",
                      backgroundColor: "#19ff6b",
                      border: "2px solid #19ff6b",
                      borderRadius: "6px",
                      padding: "2px 6px"
                    })
                  }}
                >
                    Score: {s.analysis.score || 0}
                  </span>
                     </div>

                  <div className="header-position-box">
                    <span
                      className="token-price-scoring"
                  style={{
                    ...(s.analysis.score < 6 && {
                      color: "red"
                    }),
                    ...(s.analysis.score >= 6 && s.analysis.score < 9 && {
                      color: "orange"
                    }),
                    ...(s.analysis.score >= 9 && s.analysis.score < 12 && {
                      color: "#19ff6b"
                    }),
                    ...(s.analysis.score >= 12 && {
                      color: "#330596ff",
                      backgroundColor: "#19ff6b",
                      border: "2px solid #19ff6b",
                      borderRadius: "6px",
                      padding: "2px 6px"
                    })
                  }}
                >
                      {s.analysis.scoreMeaning || "NA"}
                    </span>
                  </div>
                </div>

                <div className="header-row-position-main">
                  <div className="header-position-box">
                    <span className="token-price">Entry: {plan.entry != null ? `$${formatPriceDynamic(plan.entry)}` : "N/A"}</span>
                    <span className="token-price">TP: {plan.tp != null ? `$${formatPriceDynamic(plan.tp)}` : "N/A"}</span>
                    <span className="token-price">SL: {plan.sl != null ? `$${formatPriceDynamic(plan.sl)}` : "N/A"}</span>
                     </div> 
                  <div className="header-position-box">
                  <span className="token-price">
                    NOW ${s.currentPrice?.toFixed(4)}
                  </span>
                  <span className="token-price" style={{
                    color: gainValue >= 0 ? "limegreen" : "red"
                  }}>
                    {gainValue >= 0 ? "▲" : "▼"} {Math.abs(gainValue).toFixed(2)}% Gain
                  </span>

                  {/* Left to TP with arrow and color */}
                  <span className="token-price" style={{
                    color: leftToTP >= 0 ? "limegreen" : "red"
                  }}>
                    {leftToTP >= 0 ? "▲" : "▼"} {Math.abs(leftToTP).toFixed(2)}% Left
                  </span>
                  </div>
                </div>

                
                <div className="header-position-box">
                  {/* Success Ratio */}
                  <div className="header-position-box">
                    {(() => {
                      const sr = Number(s?.analysis?.successRatio);
                      const isNum = Number.isFinite(sr);
                      const lime = "#19ff6b";
                      const orange = "#ffab19ff";

                      const style = !isNum
                        ? {}
                        : sr >= 50
                        ? {
                            color: "black",
                            backgroundColor: lime,
                            border: `2px solid black`,
                            borderRadius: "6px",
                            padding: "2px 6px",
                            fontSize: "20px",
                          }
                        : sr >= 20
                         ? {
                            color: "black",
                            backgroundColor: orange,
                            border: `2px solid black`,
                            borderRadius: "6px",
                            padding: "2px 6px",
                            fontSize: "20px",
                          }
                        : sr < 20
                        ? {
                            color: "#fff",
                            backgroundColor: "red",
                            border: "2px solid red",
                            borderRadius: "6px",
                            padding: "2px 6px",
                            fontSize: "20px",
                          }
                        : {
                            color: "#fff",
                            backgroundColor: "blue", // neutral 0–10
                            border: "2px solid black",
                            borderRadius: "6px",
                            padding: "2px 6px",
                            fontSize: "20px",
                          };

                      return (
                        <span className="token-price" style={style}>
                          Success Ratio: {isNum ? `${sr.toFixed(1)}%` : "NA"}
                        </span>
                      );
                    })()}
                  </div>

                  {/* Avg Gain / Trade (totalProfitLoss ÷ tradesHistCount) */}
                  <div className="header-position-box">
                    {(() => {
                      const totalPL = Number(s?.analysis?.totalProfitLoss ?? NaN);
                      const trades = Number(
                        s?.analysis?.tradeHistCount
                      );
                      const avg = Number.isFinite(totalPL) && Number.isFinite(trades) && trades > 0
                        ? totalPL / trades
                        : null;
                      const orange = "#ffab19ff";
                      // --- ORANGE THEME STYLE (like Success Ratio)
                      const orangeStyle = {
                        color: "black",
                        backgroundColor: orange,
                        border: `2px solid black`,
                        borderRadius: "6px",
                        padding: "2px 6px",
                        fontSize: "20px",
                      };

                      // --- BLUE/GREEN/RED STYLES for actual values
                      const style = !Number.isFinite(avg)
                        ? orangeStyle
                        : avg > 10
                        ? { color: "black", backgroundColor: "#19ff6b", border: "2px solid black", borderRadius: "6px", padding: "2px 6px", fontSize: "20px" }
                        : avg >= 0
                        ? { color: "#fff", backgroundColor: "blue", border: "2px solid black", borderRadius: "6px", padding: "2px 6px", fontSize: "20px" }
                        : { color: "#fff", backgroundColor: "red", border: "2px solid red", borderRadius: "6px", padding: "2px 6px", fontSize: "20px" };

                      return (
                        <span className="token-price" style={style}>
                          {Number.isFinite(avg)
                            ? `Avg Gain: ${avg.toFixed(1)}%`
                            : "Avg Gain: N / A"}
                        </span>
                      );
                    })()}
                  </div>


                </div>


                {showCharts && (
                 <AnalysisChart
                    candles={s.chartFormationData?.candles || []}
                    analysis={{
                      longPosition: { entry: s.chartFormationData?.entry, tp: s.chartFormationData?.tp, sl: s.chartFormationData?.sl }
                    }}
                  />
                  )}

            {showTrigger && (
              <div
                className={`top-row-text-ai-2 trigger-${triggerStatus.toLowerCase()}`}
              >
                <strong>Status:</strong> {triggerStatus}
              </div>
            )}

            {openIndex === i && (
              <div className="expanded-section">


<div className="top-row-text-ai-3" style={{ marginTop: "1rem", textAlign: "center" }}>
  <strong>Liquidity {''} - </strong>
      <button
        onClick={handleUpdateLiquidity}
        disabled={loading}
        style={{
          fontSize: '12px',
          padding: '4px 10px',
          background: '#444',
          color: '#fff',
          border: '1px solid #888',
          borderRadius: '4px',
          cursor: loading ? "not-allowed" : "pointer",
          opacity: loading ? 0.6 : 1
        }}
      >
        {loading ? "Loading..." : "🔄 Update"}
      </button>

  <div style={{ display: "flex", justifyContent: "center", gap: "2rem", marginTop: "1rem", flexWrap: "wrap" }}>
      {(() => {
        const heatmap = s.liquidityZones?.heatmap || [];
        const obMode = isOrderBookMode(heatmap);
        const maxVol = Math.max(...heatmap.map(z => getZoneVolume(z, obMode))) || 1;

        const first  = heatmap[0];
        const middle = heatmap[Math.floor(heatmap.length / 2)];
        const last   = heatmap[heatmap.length - 1];

        const boxes = [
          { zone: first,  isTop: s.liquidityZones.topZone?.start   === first?.start,  isBottom: s.liquidityZones.bottomZone?.start === first?.start  },
          { zone: middle, isTop: s.liquidityZones.topZone?.start   === middle?.start, isBottom: s.liquidityZones.bottomZone?.start === middle?.start },
          { zone: last,   isTop: s.liquidityZones.topZone?.start   === last?.start,   isBottom: s.liquidityZones.bottomZone?.start === last?.start   },
        ];

        return boxes.map(({ zone, isTop, isBottom }, idx) => {
          if (!zone) return null;
          const zoneVol = getZoneVolume(zone, obMode);
          const intensity = Math.min(1, zoneVol / maxVol);

          return (
            <div key={idx} style={{ textAlign: "center", minWidth: "80px" }}>
              <div
                style={{
                  width: "50px",
                  height: "20px",
                  backgroundColor: `hsl(0, 100%, ${80 - intensity * 50}%)`,
                  border: isTop    ? "2px solid limegreen"
                      : isBottom ? "2px solid cyan"
                                  : "1px solid #111",
                  borderRadius: "2px",
                  margin: "0 auto"
                }}
              />
              <div style={{ fontSize: "10px", color: "#ccc", marginTop: "4px" }}>
                <strong>${zone.start.toFixed(5)}</strong><br />
                <span style={{ fontSize: "9px", color: "#888" }}>
                  {obMode ? "Resting" : "Traded"} Vol: {zoneVol.toLocaleString()}
                </span>
              </div>
            </div>
          );
        });
      })()}
  </div>

    <div className="top-row-text-ai-4" style={{ marginTop: "1rem", fontSize: "13px" }}>
      <div>
        <span style={{ display: "inline-block", width: 14, height: 14, background: "red", marginRight: 6, verticalAlign: "middle" }} />
        More Liquidity (brighter red = higher {isOrderBookMode(s.liquidityZones?.heatmap) ? "resting order size" : "traded volume"})
      </div>
    <div>
      <span style={{
        display: "inline-block",
        width: "14px",
        height: "14px",
        border: "2px solid limegreen",
        marginRight: "6px",
        verticalAlign: "middle"
      }}></span>
      Top Liquidity Zone
    </div>
    <div>
      <span style={{
        display: "inline-block",
        width: "14px",
        height: "14px",
        border: "2px solid cyan",
        marginRight: "6px",
        verticalAlign: "middle"
      }}></span>
      Bottom Liquidity Zone
    </div>
  </div>
</div>

{(() => {
  const liq = s.liquidityZones || {};
  const price =
    s.currentPrice ??
    s.priceAtAnalysis ??
    s.pr ??
    s.now;

  // use persisted fields if present; otherwise derive from heatmap + price
  const fallback = deriveSideZones(liq, price);
  const topBidZoneBelow   = liq.topBidZoneBelow   || fallback.topBidZoneBelow;
  const nearestBidBelow   = liq.nearestBidBelow   || fallback.nearestBidBelow;
  const topAskZoneAbove   = liq.topAskZoneAbove   || fallback.topAskZoneAbove;
  const nearestAskAbove   = liq.nearestAskAbove   || fallback.nearestAskAbove;

  const legendItem = (boxStyle, label, priceVal, color) => (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 8, whiteSpace: "nowrap" }}>
      <span style={boxStyle} />
      <span style={{ color }}>{label}</span>
      <span style={{ color: "#9aa0a6" }}>•</span>
      <span style={{ color: "#ddd" }}>{fmtPrice(priceVal)}</span>
    </div>
  );

  const box = (color, dashed=false) => ({
    width: 14,
    height: 14,
    borderRadius: 3,
    border: `${dashed ? "2px dashed" : "2px solid"} ${color === "green" ? "limegreen" : "red"}`
  });

  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: 16,
      justifyItems: "center",
      alignItems: "center",
      fontSize: 12,
      color: "#aaa",
      marginTop: 6,
      width: "100%",
      maxWidth: 1000,
      marginInline: "auto"
    }}>
      {legendItem(box("green", false), "Strongest Support",    zoneMid(topBidZoneBelow),   "limegreen")}
      {legendItem(box("green", true ), "Nearest Support",      zoneMid(nearestBidBelow),   "limegreen")}
      {legendItem(box("red",   false), "Strongest Resistance", zoneMid(topAskZoneAbove),   "red")}
      {legendItem(box("red",   true ), "Nearest Resistance",   zoneMid(nearestAskAbove),   "red")}
    </div>
  );
})()}


{liquidityUpdateModal?.show && (   // ← your modal continues here
  <div className="info-modal">
    <div className="info-modal-content">
      <h3>Liquidity Zones Updated</h3>

      <div>
        <strong>Bias:</strong>{" "}
        <span style={{
          color: liquidityUpdateModal.updated.bias === "long"
            ? "limegreen"
            : liquidityUpdateModal.updated.bias === "short"
            ? "red"
            : "#ccc"
        }}>
          {s.liquidityZones.bias.toUpperCase()} → {liquidityUpdateModal.updated.bias.toUpperCase()}
        </span>
      </div>

        <ul style={{ marginTop: "0.5rem", fontSize: "12px", color: "#aaa" }}>
          <div>Support (bids below): {liquidityUpdateModal.updated.meta?.supportBelow?.toLocaleString()}</div>
          <div>Resistance (asks above): {liquidityUpdateModal.updated.meta?.resistanceAbove?.toLocaleString()}</div>
          <div>Support share: {(liquidityUpdateModal.updated.meta?.supportShare * 100 || 0).toFixed(1)}%</div>
          <div>Mode: {liquidityUpdateModal.updated.meta?.mode || '—'}</div>
        </ul>


          <div style={{ marginTop: '0.5rem', fontSize: "13px" }}>
            {liquidityUpdateModal.changes.topChanged && <div>🔺 Top Zone changed</div>}
            {liquidityUpdateModal.changes.bottomChanged && <div>🔻 Bottom Zone changed</div>}
            {liquidityUpdateModal.changes.biasChanged && <div>📈 Bias changed</div>}
            {liquidityUpdateModal.changes.modeChanged && <div>🔁 Mode changed (Candles ↔ Order Book)</div>}
            {(!liquidityUpdateModal.changes.topChanged &&
              !liquidityUpdateModal.changes.bottomChanged &&
              !liquidityUpdateModal.changes.biasChanged &&
              !liquidityUpdateModal.changes.modeChanged) && (
                <div>— No meaningful changes —</div>
            )}
          </div>


        <div style={{ marginTop: "1rem", fontSize: "12px", textAlign: "center" }}>
          {(() => {
            const oldHeatmap = s.liquidityZones?.heatmap || [];
            const newHeatmap = liquidityUpdateModal.updated?.heatmap || [];
            const oldOB = isOrderBookMode(oldHeatmap);
            const newOB = isOrderBookMode(newHeatmap);

            const oldTotal = totalVolumeFor(oldHeatmap, oldOB);
            const newTotal = totalVolumeFor(newHeatmap, newOB);

            const sameMode = oldOB === newOB;
            const diff = sameMode ? (newTotal - oldTotal) : 0;

            const formattedOld = oldTotal.toLocaleString(undefined, { maximumFractionDigits: 2 });
            const formattedNew = newTotal.toLocaleString(undefined, { maximumFractionDigits: 2 });
            const absDiff = Math.abs(diff).toLocaleString(undefined, { maximumFractionDigits: 2 });
            const diffColor = diff > 0 ? "limegreen" : diff < 0 ? "red" : "#aaa";
            const modeLabel = newOB ? "Resting Liquidity (Order Book)" : "Traded Volume (Candles)";

            return (
              <div>
                <div style={{ marginBottom: 4, color: "#aaa" }}>{modeLabel}</div>
                <strong>Total:</strong> {formattedOld} → {formattedNew}{" "}
                {sameMode
                  ? <span style={{ color: diffColor }}>({diff >= 0 ? "+" : "-"}{absDiff})</span>
                  : <span style={{ color: "#aaa" }}>(mode changed)</span>}
              </div>
            );
          })()}
        </div>



          {/* Key support/resistance levels */}
          <div style={{ marginTop: "1rem", fontSize: "12px", color: "#aaa" }}>
            {(() => {
              const u = liquidityUpdateModal.updated || {};
              const obMode = isOrderBookMode(u.heatmap || []);
              const vol = (z) => obMode
                ? ((z?.bidVolume || 0) + (z?.askVolume || 0))
                : (z?.volume || 0);

              const row = (label, zone, color) => (
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                  <span style={{
                    width: 12, height: 12,
                    border: `2px solid ${color}`,
                    borderRadius: 2
                  }} />
                  <span style={{ color }}>{label}:</span>
                  <span style={{ color: "#ddd" }}>{fmtPrice(zoneMid(zone))}</span>
                  {zone && (
                    <span style={{ color: "#9aa0a6" }}>• Vol: {fmtNum(vol(zone))}</span>
                  )}
                </div>
              );

              return (
                <>
                  {row("Strongest Support",   u.topBidZoneBelow,  "limegreen")}
                  {row("Nearest Support",     u.nearestBidBelow,  "limegreen")}
                  {row("Strongest Resistance", u.topAskZoneAbove, "red")}
                  {row("Nearest Resistance",   u.nearestAskAbove, "red")}
                </>
              );
            })()}
          </div>

      {/* Mini heatmap visualization */}
      <div style={{ display: "flex", justifyContent: "center", gap: "2rem", marginTop: "1rem", flexWrap: "wrap" }}>
        {(() => {
          const heatmap = liquidityUpdateModal.updated?.heatmap || [];
          const obMode = isOrderBookMode(heatmap);
          const maxVol = Math.max(...heatmap.map(z => getZoneVolume(z, obMode))) || 1;
          const first = heatmap[0];
          const middle = heatmap[Math.floor(heatmap.length / 2)];
          const last = heatmap[heatmap.length - 1];

          const boxes = [
            { zone: first, label: "Start", isTop: liquidityUpdateModal.updated.topZone?.start === first?.start, isBottom: liquidityUpdateModal.updated.bottomZone?.start === first?.start },
            { zone: middle, label: "Mid", isTop: liquidityUpdateModal.updated.topZone?.start === middle?.start, isBottom: liquidityUpdateModal.updated.bottomZone?.start === middle?.start },
            { zone: last, label: "End", isTop: liquidityUpdateModal.updated.topZone?.start === last?.start, isBottom: liquidityUpdateModal.updated.bottomZone?.start === last?.start },
          ];

          return boxes.map(({ zone, isTop, isBottom }, idx) => {
            if (!zone) return null;
            const intensity = Math.min(1, zone.volume / maxVol);
            const zoneVol = getZoneVolume(zone, obMode);

            return (
              <div key={idx} style={{ textAlign: "center", minWidth: "80px" }}>
                <div
                  style={{
                    width: "50px",
                    height: "20px",
                    backgroundColor: `hsl(0, 100%, ${80 - intensity * 50}%)`,
                    border: isTop
                      ? "2px solid limegreen"
                      : isBottom
                      ? "2px solid cyan"
                      : "1px solid #111",
                    borderRadius: "2px",
                    margin: "0 auto"
                  }}
                />
                <div style={{ fontSize: "10px", color: "#ccc", marginTop: "4px" }}>
                  <strong>${zone.start.toFixed(5)}</strong><br />
                  <span style={{ fontSize: "9px", color: "#888" }}>
                    Vol: {zoneVol.toLocaleString()}
                  </span>

                  {/* % change logic */}
                  {(() => {
                    // Recreate the exact 3 zones originally shown
                    const initialHeatmap = s.liquidityZones?.heatmap || [];
                    const updatedHeatmap = liquidityUpdateModal.updated?.heatmap || [];

                    const oldOB = isOrderBookMode(initialHeatmap);
                    const newOB = isOrderBookMode(updatedHeatmap);

                    // The three reference zones from BEFORE (Start / Mid / End)
                    const originalFirst  = initialHeatmap[0];
                    const originalMiddle = initialHeatmap[Math.floor(initialHeatmap.length / 2)];
                    const originalLast   = initialHeatmap[initialHeatmap.length - 1];
                    const originalZones  = [originalFirst, originalMiddle, originalLast];

                    // 'zone' is the *updated* zone passed by the outer map; 'idx' matches Start/Mid/End
                    const matchedInitial = originalZones[idx];

                    const oldVol = getZoneVolume(matchedInitial, oldOB);
                    const newVol = getZoneVolume(zone, newOB);

                    let formatted = "—";
                    let color = "#aaa";

                    if (oldOB === newOB) {
                      if (oldVol === 0 && newVol > 0) {
                        formatted = "+∞%";
                        color = "limegreen";
                      } else if (oldVol > 0) {
                        const change = ((newVol - oldVol) / oldVol) * 100;
                        formatted = `${change > 0 ? "+" : ""}${change.toFixed(1)}%`;
                        color = change > 0 ? "limegreen" : change < 0 ? "red" : "#aaa";
                      }
                    } else {
                      formatted = "mode changed";
                    }

                    return (
                      <div style={{ fontSize: "9px", color, marginTop: "2px" }}>
                        {formatted}
                      </div>
                    );
                  })()}
                </div>
              </div>
            );
          });
        })()}
      </div>

      <button
        className="info-modal-content"
        onClick={() => setLiquidityUpdateModal(null)}
        style={{
          marginTop: "1rem",
          padding: "8px 18px",
          background: "#006eff",
          borderRadius: "6px",
          border: "none",
          color: "#fff",
          fontSize: "14px",
          cursor: "pointer"
        }}
      >
        Close
      </button>
    </div>
  </div>
)}






                {s.analysis.chartPattern !== "None" && (
                  <div className="top-row-text-ai-3">
                    <strong>Market Pulse:</strong> {s.analysis.marketPulse}
                  </div>
                )}
                <div className="top-row-text-ai-3">
                  <strong>MACD:</strong> {s.analysis.macd}
                </div>
                <div className="top-row-text-ai-3">
                  <strong>RSI:</strong> {s.analysis.rsi}
                </div>
                <div className="top-row-text-ai-3">
                  <strong>Volume:</strong> {s.analysis.volume}
                </div>
                {s.analysis.catalysts && s.analysis.catalysts !== "None" && (
                  <div className="top-row-text-ai-3">
                    <strong>Catalysts:</strong> {s.analysis.catalysts}
                  </div>
                )}
                <div className="top-row-text-ai-3">
                  <strong>Justification:</strong> {s.analysis.justification}
                </div>


                {s.analysis.entryConditions && (
                  <div className="top-row-text-ai-3">
                    <strong>Entry Conditions:</strong>{" "}
                    {s.analysis.entryConditions}
                  </div>
                )}
               {s.triggerSnapshot?.justification && (
                 <div className="top-row-text-ai-3" style={{ marginTop: "0.5rem" }}>
                    <strong>Re-assessment:</strong> {s.triggerSnapshot.triggeredDirection} ▶️ Triggered at ${s.triggerSnapshot.triggeredPrice} ▶️ Trend {s.triggerSnapshot.trendStrength} ▶️ Confidence {s.triggerSnapshot.confidenceLevel}
                        {/* Display gain based on triggered direction */}
                    {s.triggerSnapshot.triggeredDirection === "LONG" && typeof s.triggerSnapshot.longGain === "number" && (
                      <> ▶️ Est. Gains: {s.triggerSnapshot.longGain.toFixed(2)}%</>
                    )}
                    {s.triggerSnapshot.triggeredDirection === "SHORT" && typeof s.triggerSnapshot.shortGain === "number" && (
                      <> ▶️ Est. Gains: {s.triggerSnapshot.shortGain.toFixed(2)}%</>
                    )}
                    <p> {s.triggerSnapshot.justification} / TP Chance {s.triggerSnapshot.tpChance} / SL Chance {s.triggerSnapshot.slChance}</p>
                  </div>
                )}
                <div className="top-row-text-ai-3" style={{ marginTop: "1rem" }}>
              <a
                href={`https://www.binance.com/en/trade/${s.token.replace("/", "_")}`}
                target="_blank"
                rel="noopener noreferrer"
                className="binance-chart-link"
              >
                📊 View on Binance
              </a>
            </div>
               <div className="top-row-text-ai-3" style={{ marginTop: "1rem" }}>
                  <TradeFlyer suggestion={s} />
                </div>

                {typeof s.analysis.localSupport === "number" &&
                  typeof s.analysis.localResistance === "number" && (
                    <div
                      className="top-row-text-ai-3"
                      style={{ marginTop: "1rem" }}
                    >
                      <strong>Support/Resistance Zones:</strong>
                      <br />
                      🟩 Support ({s.analysis.timeframeUsed}):{" "}
                      <span style={{ color: "limegreen" }}>
                        ${s.analysis.localSupport.toFixed(4)}
                      </span>
                      <br />
                      🟥 Resistance ({s.analysis.timeframeUsed}):{" "}
                      <span style={{ color: "crimson" }}>
                        ${s.analysis.localResistance.toFixed(4)}
                      </span>
                    </div>
                  )}

                <div className="options-container">
                  {(() => {
                    const isBullish = trend === "bullish";
                    const isBearish = trend === "bearish";

                    const longClass = isBullish
                      ? "long-short-block highlighted-block"
                      : isBearish
                      ? "long-short-block warning-block"
                      : "long-short-block";
                    const shortClass = isBearish
                      ? "long-short-block highlighted-block"
                      : isBullish
                      ? "long-short-block warning-block"
                      : "long-short-block";

                    return (
                      <>
                        {s.longPosition && (
                          <div className={longClass}>
                            <div className="top-row-text-ai-1">
                              📈 Long Position
                            </div>
                            <div>
                              <strong>Entry:</strong> ${s.longPosition.entry}
                            </div>
                            <div>
                              <strong>TP:</strong> ${s.longPosition.tp}
                            </div>
                            <div>
                              <strong>SL:</strong> ${s.longPosition.sl}
                            </div>
                            <div>
                              <strong>Risk To Reward:</strong>{" "}
                              {s.longPosition.riskReward}
                            </div>
                            {typeof s.longGain === "number" && (
                              <div>
                                <strong>Projected Gain:</strong>{" "}
                                {s.longGain.toFixed(2)}%
                              </div>
                            )}
                          </div>
                        )}

                        {s.shortPosition && (
                          <div className={shortClass}>
                            <div className="top-row-text-ai-1">
                              📉 Short Position
                            </div>
                            <div>
                              <strong>Entry:</strong> ${s.shortPosition.entry}
                            </div>
                            <div>
                              <strong>TP:</strong> ${s.shortPosition.tp}
                            </div>
                            <div>
                              <strong>SL:</strong> ${s.shortPosition.sl}
                            </div>
                            <div>
                              <strong>Risk To Reward:</strong>{" "}
                              {s.shortPosition.riskReward}
                            </div>
                            {typeof s.shortGain === "number" && (
                              <div>
                                <strong>Projected Gain:</strong>{" "}
                                {s.shortGain.toFixed(2)}%
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    );
                  })()}
                </div>
              </div>
            )}
            </BlurIfLocked>
          </div>
        );
      })}

      <div className="pagination-controls">
        <button
          className="page-button"
          onClick={() => setCurrentDateIndex((i) => Math.max(i - 1, 0))}
          disabled={currentDateIndex === 0}
        >
          ◀ Prev Day
        </button>
        <span>{currentDate}</span>
        <button
          className="page-button"
          onClick={() =>
            setCurrentDateIndex((i) => Math.min(i + 1, sortedDates.length - 1))
          }
          disabled={currentDateIndex === sortedDates.length - 1}
        >
          Next Day ▶
        </button>
      </div>

      


          <Modal
            isOpen={isChartOpen}
            onRequestClose={closeChart}
            contentLabel="TradingView Chart"
            style={{
              content: {
                width: isMobile ? '100%' : '98%',
                height: isMobile ? '100%' : '95%',
                margin: 'auto',
                backgroundColor: '#111',
                borderRadius: '12px',
                padding: '10px',
                inset: 'unset', // override default inset
              },
              overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.85)',
                zIndex: 1000
              }
            }}
          >
        <button onClick={closeChart} style={{ float: 'right', background: 'none', color: '#fff' }}>
          ✖ Close
        </button>
        {chartSymbol && (
          <iframe
            src={`https://www.tradingview.com/widgetembed/?symbol=${chartSymbol}&interval=60&hidesidetoolbar=1&hideideas=1&theme=dark&studies=RSI@tv-basicstudies,MACD@tv-basicstudies`}
            style={{ width: '100%', height: '90%' }}
            frameBorder="0"
            title="TradingView Chart"
          />
        )}
      </Modal>
          <Modal
            isOpen={tradeModal.open}
            onRequestClose={() => setTradeModal(m => ({ ...m, open: false }))}
            contentLabel="Open Position"
            className="modal"                 // content panel
            overlayClassName="modal-overlay"  // overlay
            shouldCloseOnOverlayClick={true}
            shouldCloseOnEsc={true}
          >
            {!tradeModal.unlocked ? (
              <>
                <h3>Enter Trading PIN</h3>
                <p>For safety, confirm a session PIN to place orders.</p>

                <input
                  type="password"
                  className="input"
                  value={tradeModal.pin}
                  onChange={(e) => setTradeModal(m => ({ ...m, pin: e.target.value }))}
                  placeholder="PIN"
                />

                <div className="modal-actions">
                  <button onClick={() => setTradeModal(m => ({ ...m, open: false }))}>Cancel</button>
                  <button
                    onClick={() => {
                      if ((tradeModal.pin || "").length < 4) {
                        alert("PIN must be at least 4 characters.");
                        return;
                      }
                      setTradeModal(m => ({ ...m, unlocked: true }));
                    }}
                    className="danger"
                  >
                    Unlock
                  </button>
                </div>
              </>
            ) : (
              <>
                <h3 style={{ marginTop: 4, opacity: 0.9 }}>{tradeModal.token}</h3>

                <div style={{ display: "grid", gap: 10 }}>
                  <div>
                    <label>Bot</label>
                    <select
                      className="input"
                      value={tradeModal.bot}
                      onChange={(e) => setTradeModal(m => ({ ...m, bot: e.target.value }))}
                    >
                      <option value="binance">Binance CRG</option>
                      <option value="bitget">Bitget Fam</option>
                    </select>
                  </div>
                  
                   <div style={{ display: "grid", gridTemplateColumns: "2fr 2fr", gap: 10 }}>
                     <div>
                    <label>Direction</label>
                    <select
                      className="input"
                      value={tradeModal.direction}
                      onChange={(e) => {
                        const direction = e.target.value;
                        const p = planFor(tradeModal.rawSuggestion, direction);
                        setTradeModal(m => ({ ...m, direction, entry: p.entry, tp: p.tp, sl: p.sl }));
                      }}
                    >
                      <option value="LONG">LONG</option>
                      <option value="SHORT">SHORT</option>
                    </select>
                     </div>
                    <div>
                    <label>Order Size (qtyUsd)</label>
                    <input
                      className="input"
                      type="number"
                      min="1"
                      step="1"
                      value={tradeModal.qtyUsd}
                      onChange={(e) => setTradeModal(m => ({ ...m, qtyUsd: e.target.value }))}
                      placeholder="e.g. 50"
                    />
                 
                  </div>
                    </div>


                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                    <div>
                      <label>Entry</label>
                      <input
                        className="input"
                        type="number"
                        value={tradeModal.entry ?? ""}
                        onChange={(e) => setTradeModal(m => ({ ...m, entry: Number(e.target.value) || null }))}
                      />
                    </div>
                    <div>
                      <label>TP</label>
                      <input
                        className="input"
                        type="number"
                        value={tradeModal.tp ?? ""}
                        onChange={(e) => setTradeModal(m => ({ ...m, tp: Number(e.target.value) || null }))}
                      />
                    </div>
                  </div>

                  <div>
                    <label>SL</label>
                    <input
                      className="input"
                      type="number"
                      value={tradeModal.sl ?? ""}
                      onChange={(e) => setTradeModal(m => ({ ...m, sl: Number(e.target.value) || null }))}
                    />
                  </div>
                  {(() => {
                      const isLong   = tradeModal.direction === 'LONG';
                      const entry    = Number(tradeModal.entry) || NaN;
                      const tp       = Number(tradeModal.tp)    || NaN;
                      const sl       = Number(tradeModal.sl)    || NaN;
                      const qtyUsd   = Number(tradeModal.qtyUsd) || 0;   // user “margin”
                      const lev      = Number(botLeverage) || 10;

                      // prefer live “now”; fall back to priceAtAnalysis; lastly entry
                      const now =
                        Number(tradeModal.rawSuggestion?.currentPrice) ||
                        Number(tradeModal.rawSuggestion?.priceAtAnalysis) ||
                        entry;

                      // percent moves from entry
                      const pctNow = Number.isFinite(entry) && entry > 0 && Number.isFinite(now)
                        ? (isLong ? (now - entry) / entry : (entry - now) / entry)
                        : 0;

                      const pctTp  = Number.isFinite(entry) && entry > 0 && Number.isFinite(tp)
                        ? (isLong ? (tp - entry) / entry : (entry - tp) / entry)
                        : 0;

                      const pctSl  = Number.isFinite(entry) && entry > 0 && Number.isFinite(sl)
                        ? (isLong ? (sl - entry) / entry : (entry - sl) / entry)
                        : 0;

                      // approximate $PnL using your backend sizing convention (qtyUsd = margin)
                      const pnlNowUsd = qtyUsd * lev * pctNow;
                      const pnlTpUsd  = qtyUsd * lev * pctTp;
                      const pnlSlUsd  = qtyUsd * lev * pctSl;

                      const fmtPct = (x) => `${(x * 100).toFixed(2)}%`;
                      const fmtUsd = (x) => `$${(x || 0).toFixed(2)}`;

                      return (
                        <div style={{
                          marginTop: 12, padding: 10, borderRadius: 8, background: '#0f0f0f',
                          border: '1px solid #222', display: 'grid', gap: 6
                        }}>
                          <div style={{opacity:.85}}>
                            <strong>Leverage:</strong> {lev}×
                          </div>
                          <div>
                            <strong>Live Δ:</strong> {fmtPct(pctNow)} ({fmtUsd(pnlNowUsd)})
                          </div>
                          <div style={{color:'lime'}}>
                            <strong>At TP:</strong> {fmtPct(pctTp)} ({fmtUsd(pnlTpUsd)})
                          </div>
                          <div style={{color:'salmon'}}>
                            <strong>At SL:</strong> {fmtPct(pctSl)} ({fmtUsd(pnlSlUsd)})
                          </div>
                          <div style={{opacity:.6, fontSize:12}}>
                            * Estimates based on qtyUsd × leverage and current/entry/TP/SL.
                          </div>
                        </div>
                      );
                    })()}

                </div>

                <div className="modal-actions">
                  <button onClick={() => setTradeModal(m => ({ ...m, open: false }))}>Cancel</button>
                  <button className="danger" onClick={submitOpenPosition}>Place Order</button>
                </div>
              </>
            )}
          </Modal>
            <div
              style={{
                position: 'fixed',
                right: '16px',
                bottom: '16px',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                zIndex: 999,
              }}
            >
              <button
                onClick={scrollToTop}
                className="page-button"
                style={{ padding: '8px 10px', borderRadius: 6 }}
                title="Scroll to top"
              >
                ⬆ Top
              </button>
              <button
                onClick={scrollToBottom}
                className="page-button"
                style={{ padding: '8px 10px', borderRadius: 6 }}
                title="Scroll to bottom"
              >
                ⬇ Bottom
              </button>
            </div>


    </div>
  );
}

export default AiTradeSuggestionList;
